import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, from} from "rxjs";
 
import {Subscription} from "rxjs"; 
import {delay, map, switchMap} from 'rxjs/operators';
import {ActivatedRoute, Params, Router} from '@angular/router';
import * as moment from 'moment';
 
import {MarketingPartnerService} from '../shared/services/marketing-partner.service'
import { NbDialogService, NbToastrService, NbGlobalPosition } from '@nebular/theme';
 
 import {domain, protocol} from '../shared/config';
 
@Component({
  selector: 'app-partner-stat-page', 
  templateUrl: './partner-stat-page.component.html',
  styleUrls: ['./partner-stat-page.component.scss'],
  
})
export class PartnerStatPageComponent implements OnInit, OnDestroy, AfterViewInit{
 
 lSub$:any 
  stat_id = null
 partner = null
  waitPassword = true
    password = ''
  passwordError = ''	
  loading:boolean = false

  constructor(  private toastrService: NbToastrService,
     private dialogService: NbDialogService, 
	 private marketingPartnerService: MarketingPartnerService,
	 public route:  ActivatedRoute,
	  private router: Router
   ){
  }
   
 
   ngOnInit() { 

	

 	this.lSub$ = this.route.params.subscribe((params: Params)=>{
        	this.stat_id = params['id']

	 	let tkn = localStorage.getItem('partner_stat_'+this.stat_id)

		if(tkn){
			this.load(true, tkn)
		}
      },(err)=>{

		//console.log(err)
		//this.router.navigate(['/channel'])
				//return

	})
 
	 
 
  }

   

 

 loadWithPass(){
	if(!this.password){return}
	this.load(false,this.password)

 }



 load(hasToken, data){

	if(this.lSub$){
		this.lSub$.unsubscribe()
	}

	 this.loading = true
	 this.passwordError = ''

	this.lSub$ =   this.marketingPartnerService.getPublishStat(this.stat_id,hasToken, data).subscribe( (stat: any)=>{
 
	    this.partner = stat
	   this.loading = false
            localStorage.setItem('partner_stat_'+this.stat_id, stat.token)

		this.waitPassword = false
          },({error})=>{

		if(error.tokenError === true){
			this.waitPassword = true
			localStorage.removeItem('partner_stat_'+this.stat_id)
		} else if(error.passError === true){

			 this.waitPassword = true
		  	 this.passwordError = 'Неправильний пароль'
			 localStorage.removeItem('partner_stat_'+this.stat_id)
		} else if(error.needAuthorize === true){

			 this.waitPassword = true
			 localStorage.removeItem('partner_stat_'+this.stat_id)
		} else  {
			this.router.navigate(['/channel'])
				 return
		
		}
	  	 this.loading = false


		//this.router.navigate(['/channel'])
				//return

	})
         
}
 

/**/

  
   ngAfterViewInit() {
 
   }
 
   ngOnDestroy() {
   	if(this.lSub$){
		this.lSub$.unsubscribe()
	} 

	
   }
 
 
 
   
/**/
 
  
}
